import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import IconButton from '@material-ui/core/IconButton';
import NotificationsCircle from './NotificationsCircle';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import NotificationItem from './NotificationItem';
import NotificationModal from './NotificationModal';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import _find from 'lodash/find';
import _isNumber from 'lodash/isNumber';

import combineStyles from '../../utils/combineStyles';
import TypographyStyles from '../../styles/typography';
import { AppContext, AppProvider } from '../../AppProvider';

import * as Queries from '../../graphQL/queries/notificationLogQueries';
import * as Mutations from '../../graphQL/mutations/notificationLogMutations';

import NotificationLogMetadata from './Notifications.metadata';
import { DEFAULT_ROWS_PER_PAGE } from '../../constants/constants';

const styles = () => ({
  iconButtonRoot: {
    position: 'relative'
  },
  menulist: {
    height: 'calc(100vh - 120px)',
    overflow: 'hidden',
    overflowY: 'auto',
    padding: 0
  },
  settingsIcon: {
    color: 'rgba(12,31,44,0.54)'
  }
});

export class Notifications extends Component {
  static propTypes = {
    client: PropTypes.object.isRequired // comes from withApollo
  };

  state = {
    open: false,
    notifications: [],
    notification: {},
    openedModal: false,
    rowsPerPage: localStorage.getItem('PropelRowsPerPage')
      ? parseInt(localStorage.getItem('PropelRowsPerPage'), 10)
      : DEFAULT_ROWS_PER_PAGE,
    page: 0,
    totalCount: 0,
    offset: 0,
    includeViewed: true,
    loading: true
  };

  componentDidMount() {
    document.addEventListener('mousedown', this._handleClickAway);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this._handleClickAway);
  }

  _handleToggle = async () => {
    const { client: ApolloClient } = this.props;
    const { currentOrgId } = this.context.globalProps;
    const { page, rowsPerPage, includeViewed } = this.state;
    const offset = page * rowsPerPage;

    try {
      const {
        data: {
          notificationLog: {
            paged: { results, totalCount }
          }
        }
      } = await ApolloClient.query({
        query: Queries.notificationLogPaged,
        variables: {
          limit: rowsPerPage,
          offset,
          includeViewed,
          orgId: currentOrgId
        },
        fetchPolicy: 'network-only'
      });
      this.setState({
        notifications: NotificationLogMetadata.formatData(results),
        totalCount: _isNumber(totalCount) ? totalCount : this.state.totalCount
      });
    } catch (error) {
      this.setState({
        error
      });
    } finally {
      this.setState({
        loading: false
      });
    }
    this.setState(state => ({ open: !state.open }));
    this._markNotificationsAsViewed();
  };

  _handleClickAway = ({ target }) => {
    if (
      // eslint-disable-next-line
      (this.node && ReactDOM.findDOMNode(this.node).contains(target)) ||
      this.state.openedModal
    ) {
      return this.setState({
        open: true
      });
    }

    return this.setState({
      open: false
    });
  };

  _handleClick = id => {
    const notifications = [...this.state.notifications];
    const notification = _find(notifications, { id });

    if (notification.status === 'done') {
      return false;
    }

    notification['status'] = 'read';
    this.setState({
      notifications: notifications.map(notificationItem => {
        return notificationItem.id === notification.id
          ? notification
          : notificationItem;
      })
    });

   // if (notification.displayMore) {
      return this.setState({ openedModal: true, notification });
    // } else {
    //   return this.props.history.push(notification.link);
    // }
  };

  _handleViewDetails = () => {
    const { notification } = this.state;
    this._handleCloseModal();
    return this.props.history.push(notification.link);
  };

  _markNotificationsAsViewed = async () => {
    const { notifications } = this.state;

    const notificationIds = notifications.map(notification => notification.id);

    try {
      const { client: ApolloClient } = this.props;

      await ApolloClient.mutate({
        mutation: Mutations.markMultipleNotificationsViewed,
        variables: { notificationIds }
      });

      AppProvider.resetUnreadNotificationCount();
    } catch (error) {
      this.setState({
        error
      });
    }
  };

  _handleCloseModal = () => this.setState({ openedModal: false });

  render() {
    const { t, classes } = this.props;
    const { unreadNotificationCount } = this.context;

    return (
      <Fragment>
        <IconButton
          buttonRef={node => {
            this.anchorEl = node;
          }}
          aria-label="Visibility"
          classes={{ root: classes.iconButtonRoot }}
          onClick={this._handleToggle}
          title={t('Notifications')}
        >
          <NotificationsIcon />
          {unreadNotificationCount > 0 && <NotificationsCircle />}
        </IconButton>
        <Popper
          open={this.state.open}
          anchorEl={this.anchorEl}
          transition
          disablePortal
          modifiers={{
            offset: {
              enabled: true,
              offset: '0,4.5'
            }
          }}
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              id="menu-list-grow"
              style={{ transformOrigin: 'center top' }}
            >
              <Paper
                style={{ borderRadius: 0, width: 256 }}
                ref={node => (this.node = node)}
              >
                <Fragment>
                  <MenuItem
                    style={{ backgroundColor: 'transparent', height: 35 }}
                  >
                    <p className={classes.headline7}>{t('Notifications')}</p>
                  </MenuItem>
                  <Divider />
                  <MenuList className={classes.menulist}>
                    {this.state.notifications.map(notification => (
                      <NotificationItem
                        {...notification}
                        onClick={this._handleClick}
                        key={notification.id}
                      />
                    ))}
                  </MenuList>
                </Fragment>
              </Paper>
            </Grow>
          )}
        </Popper>
        <NotificationModal
          open={this.state.openedModal}
          onClose={this._handleCloseModal}
          notification={this.state.notification}
          viewDetails={this._handleViewDetails}
        />
      </Fragment>
    );
  }
}

Notifications.contextType = AppContext;
const NotificationsTranslated = withNamespaces()(Notifications);

export default withApollo(
  withRouter(
    withStyles(combineStyles(TypographyStyles, styles))(NotificationsTranslated)
  )
);
